var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 16.5V18.1406C19.9375 19.0456 19.2012 19.7812 18.2969 19.7812H4.1875C2.73981 19.7812 1.5625 18.6039 1.5625 17.1562C1.5625 17.1562 1.5625 6.00984 1.5625 6C1.5625 4.55231 2.73981 3.375 4.1875 3.375H16.3281C16.8722 3.375 17.3125 3.816 17.3125 4.35938C17.3125 4.90275 16.8722 5.34375 16.3281 5.34375H4.1875C3.82591 5.34375 3.53125 5.63775 3.53125 6C3.53125 6.36225 3.82591 6.65625 4.1875 6.65625H18.2969C19.2012 6.65625 19.9375 7.39191 19.9375 8.29688V9.9375H16.6562C14.847 9.9375 13.375 11.4095 13.375 13.2188C13.375 15.028 14.847 16.5 16.6562 16.5H19.9375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 11.25V15.1875H16.6562C15.5688 15.1875 14.6875 14.3062 14.6875 13.2188C14.6875 12.1313 15.5688 11.25 16.6562 11.25H19.9375Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 16,
    r: 5,
    fill: "#04AE3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17L5.14286 18.5L9 14",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6b98ef9930898cd20f6a28ee6405e4c3.svg";
export { ForwardRef as ReactComponent };